import { alpha, Box, ButtonBase, ButtonBaseProps, Stack, StackProps, styled } from "@mui/material";
import Placeholder from "@Resources/game/backgrounds/3.jpg";

export const ChallengeCardSimpleButtonBase = styled((props: ButtonBaseProps) => <ButtonBase disableRipple {...props} />)(({ theme, disabled }) => ({
  display: "block",
  position: "relative",
  "&:hover": {
    "& #backgroundImage": {
      transform: "scale(1.05)",
    },
  },
}));

interface IChallengeCardSimpleGlossWrapper {
  height: number | string;
  width: number | string;
}

export const ChallengeCardSimpleGlossWrapper = styled(Box)<IChallengeCardSimpleGlossWrapper>(({  }) => ({
  position: "relative",
  transition: `transform 0.5s cubic-bezier(0.18, 0.9, 0.58, 1)`,
}));

export const ChallengeCardSimpleImage = styled(Box)<{ disabled?: boolean; imageUrl?: string | null }>(({ theme, disabled, imageUrl }) => ({
  width: "100%",
  height: "100%",
  backgroundImage: `url(${imageUrl || Placeholder})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  transform: "scale(1)",
  transition: `transform 0.5s cubic-bezier(0.18, 0.9, 0.58, 1)`,
}));

export const ChallengeCardBlur = styled(Box)(({}) => ({
  position: "absolute",
  inset: 0,
  backdropFilter: "blur(4px)",
  background: "rgba(18, 19, 22, 0.20)",
}));

/**
 * @param color - Color in the form of a hexadecimal value (important)
 */
export const ChallengeCardIconWrapper = styled(Stack)<{ color?: string }>(({ color }) => ({
  background: color ? `${color}60` : "rgba(32, 33, 36, 0.60)",
  height: "100%",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
}));

export const ChallengeCardSimpleTopRight = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(2),
  right: theme.spacing(2),
}));

export const InfoTag = styled((props: StackProps) => <Stack spacing={0.75} direction="row" {...props} />)(({ theme }) => ({
  backgroundFilter: "blur(12px)",
  backgroundColor: theme.palette.dsSurface.v300,
  padding: theme.spacing(1, 1.25),
}));

export const NotPublishedTag = styled(Box)(({ theme }) => ({
  position: "absolute",
  backgroundColor: "rgba(254, 74, 74, 0.851)",
  padding: theme.spacing(1.25, 0),
  width: "100%",
  color: "white",
  bottom: 0,
  left: 0,
}));

export const BetaTag = styled(NotPublishedTag)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.dsPrimary.v300, 0.85),
}));

export const ChallengeCardLargeRoot = styled(Box)<{ imageUrl?: string | null }>(({ imageUrl }) => ({
  position: "relative",
  height: "100%",
  isolation: "isolate",
  backgroundImage: `url(${imageUrl || Placeholder})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
}));

export const ChallengeCardLargeContentWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  padding: theme.spacing(6),
  zIndex: 100,
}));

export const ChallengeCardLargeLeftContent = styled(Stack)(({ theme }) => ({
  maxWidth: theme.spacing(90),
}));
